import { ROUTES } from "./routes.constant";
import {
  IconBuildingBank,
  IconListDetails,
  IconDashboard,
  IconRosetteDiscountCheck,
  IconList,
  IconSettings,
  IconThumbUp,
  IconReceiptRefund,
  IconClipboardList,
  IconMessageQuestion,
} from "@tabler/icons-react";
import type { TablerIcon } from "@tabler/icons-react";

export type MenuItem = {
  name: string;
  icon: TablerIcon;
  path: string;
  access_name: string;
  /** Visible only when event status is archived (cancelled/deleted). */
  archivedOnly?: boolean;
  /** Visible only for completed / archived events (read-only event summary). */
  pastEventOnly?: boolean;
};

export const MENU: MenuItem[] = [
  {
    name: "Dashboard",
    icon: IconDashboard,
    path: ROUTES.DASHBOARD.path,
    access_name: "dashboard",
  },
  {
    name: "Registration",
    icon: IconListDetails,
    path: ROUTES.REGISTRATION.path,
    access_name: "registrations",
  },
  {
    name: "BIB Assignment",
    icon: IconList,
    path: ROUTES.BIB_ASSIGNMENT.path,
    access_name: "bib",
  },
  {
    name: "Corral Allocation",
    icon: IconSettings,
    path: ROUTES.CORRAL_ALLOCATION.path,
    access_name: "corral",
  },
  {
    name: "Coupons",
    icon: IconRosetteDiscountCheck,
    path: ROUTES.DISCOUNT.path,
    access_name: "discounts",
  },
  {
    name: "Payouts",
    icon: IconBuildingBank,
    path: ROUTES.PAYOUTS.path,
    access_name: "payouts",
  },
  {
    name: "Review",
    icon: IconThumbUp,
    path: ROUTES.REVIEW.path,
    access_name: "review",
  },
  {
    name: "Change Requests",
    icon: IconMessageQuestion,
    path: ROUTES.CHANGE_REQUESTS.path,
    access_name: "dashboard",
  },
  {
    name: "Refunds",
    icon: IconReceiptRefund,
    path: "/refunds/:id",
    access_name: "refunds",
    archivedOnly: true,
  },
  {
    name: "Event Details",
    icon: IconClipboardList,
    path: ROUTES.REVIEW_AND_PUBLISH.path,
    access_name: "dashboard",
    pastEventOnly: true,
  },
];
